interface CommonState {
  isProfileMenuOpen: boolean;
}

export const commonInitialState: CommonState = {
  isProfileMenuOpen: false,
};
